import { API } from "src/constants";

import { Http } from "../http";

import { BrandsResponse } from "./brands.types";

export const getBrands = (): BrandsResponse => Http.get(`${API}/brands_alter/`);
